// general script
import { handleScrollButtonCLick, hideButtonOnScroll } from './scroll-action';

$(document).ready(function() {
	collapse();
	handleMobileNavigation();
	handleDesktopNavigation();
	anchorLink();
	handleStickyConversionBar();
	formSubmitTrigger();
	comparePrices();
	eventBeacon();
	handleScrollButtonCLick();
	hideButtonOnScroll();
});

// sticky userbar with conversion elements
function handleStickyConversionBar() {
	let $win = $(window),
		winH = $win.height(),
		$bar = $('.sticky-conversion-bar'),
		$stickycontact = $('.sticky-contact-bar'),
		$barToggle = $('.sticky-conversion-bar-toggle'),
		$loginRegisterButtons = $('.mobile-bottom-userbar'),
		$lpContact = $('.lp-contact');

	if (!$bar.length) {
		return;
	}

	$win.on('load scroll resize', function() {
		let winT = $(this).scrollTop(),
			winB = winT + winH,
			lpContactTopOffset = $lpContact.offset().top;

		$barToggle.each(function() {
			let $this = $(this),
				thisT = $this.offset().top,
				thisH = $this.outerHeight(),
				thisB = thisT + thisH,
				thisInView = (thisT <= winB) && (thisB >= winT);

			$loginRegisterButtons.toggleClass('stuck', !thisInView);

			// Display Sticky Contact when form not shown and lpContact Section not reached
			$stickycontact.toggleClass('stuck', (!thisInView && (lpContactTopOffset >= winB)));
		});

	});
}

function formSubmitTrigger() {
	let $link = $('.form-submit-trigger');
	$link.on('click', function(e) {
		e.preventDefault();
		let form = $('#' + $(this).data('form-id'));
		if (form.length) {
			form.submit();
		}
	});
}

function anchorLink() {
	$('a[href^=\\#]').on('click', function(e) {
		var href = $(this).attr('href'),
			userbarHeight = $('.userbar').outerHeight() || 100;

		if ($(href)[0]) {
			$('html, body').animate({
				scrollTop: $(href).offset().top - (userbarHeight + 10)
			}, 'fast');
			e.preventDefault();
		}
	});
}

function comparePrices() {
	let $this = $('#compare-prices'),
		averageIncome = $this.data('avg-income'),
		averageProvision = $this.data('avg-provision'),
		$input = $('#compare-prices-input'),
		inputVal = $input.val(),
		inputMin = $input.attr('min'),
		inputMax = $input.attr('max'),
		$income = $('#compare-prices-income'),
		$provision = $('#compare-prices-provision'),
		$insertion = $('#compare-prices-insertion');

	handleInput();

	function handleInput() {
		handleOutput(Number(inputVal));

		$input.on('input', function() {
			inputVal = $(this).val();

			handleOutput(Number(inputVal));
		});
	}

	function handleOutput(val) {
		val = checkMinMax(val);

		$input.val(val);

		let income = val * averageIncome,
			provision = income * (averageProvision / 100);

		$income.text(formatNumber(income, '', '', '.'));
		$provision.text(formatNumber(provision, '', '', '.'));
	}

	function checkMinMax(val) {
		if (inputMin && val < Number(inputMin)) {
			val = inputMin;
		} else if (inputMax && val > Number(inputMax)) {
			val = inputMax;
		}

		return val;
	}

	function formatNumber(number, decimals, dec_point, thousands_sep) {
		let n = !isFinite(+number) ? 0 : +number,
			prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
			sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
			dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
			s = '',
			toFixedFix = function(n, prec) {
				let k = Math.pow(10, prec);
				return '' + Math.round(n * k) / k;
			};
		// Fix for IE parseFloat(0.55).toFixed(0) = 0;
		s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
		if (s[0].length > 3) {
			s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
		}
		if ((s[1] || '').length < prec) {
			s[1] = s[1] || '';
			s[1] += new Array(prec - s[1].length + 1).join('0');
		}
		return s.join(dec);
	}
}

/* Off-canvas menu for mobile screen */
function handleMobileNavigation() {
	let mobileNavigationContainer = $('.sliding-mobile-navigation');
	let burgerMenuButton = $('.userbar__burger-menu-button');
	let mobileNaviLinks = $(mobileNavigationContainer).find('a');
	let offCanvas = $('.off-canvas-toggle');

	offCanvas.on('click', function() {
		let $nav = $('nav');
		if ($nav.hasClass('on')) {
			$nav.removeClass('on');
			offCanvas.removeClass('on');
			window.setTimeout(function() {
				hidePageOverlay();
				unsetScrollFix();
			}, 150);

		} else {
			showPageOverlay();
			setScrollFix();
			window.setTimeout(function() {
				$('nav').addClass('on');
				offCanvas.addClass('on');
			}, 150);

			// hide off-canvas elements per click on page overlay
			$('.page-overlay').on('click', function() {
				$('nav').removeClass('on');
				offCanvas.removeClass('on');
				window.setTimeout(function() {
					hidePageOverlay();
					unsetScrollFix();
				}, 150);
			});
		}
	});

	burgerMenuButton.on('click', function() {
		mobileNavigationContainer.toggleClass('is-open');
		burgerMenuButton.toggleClass('is-open');
	});

	mobileNaviLinks.on('click', function() {
		mobileNavigationContainer.removeClass('is-open');
		burgerMenuButton.removeClass('is-open');
	});
}

/* Fade in grey page overlay */
function showPageOverlay() {
	let $body = $('body'),
		userbar = $body,
		currentOverlay = $body.find('.page-overlay'),
		overlayTemplate = $('<div class="page-overlay"></div>');

	if (!currentOverlay.length && userbar.length) {
		overlayTemplate.prependTo(userbar).fadeIn(200);

		// hover-effect on menu-button
		$('.mobile-navigation-wrapper').addClass('on');
	}
}

/* Fade out grey page overlay */
function hidePageOverlay() {
	let currentOverlay = $('body').find('.page-overlay');

	if (currentOverlay.length) {
		currentOverlay.fadeOut(200, function() {
			$(this).remove();
		});

		// no hover effect on menu-button
		$('.mobile-navigation-wrapper').removeClass('on');
	}
}

/* disable scrolling */
function setScrollFix() {
	let scrollTop = $(document).scrollTop(),
		html = $('html');

	html.addClass('fixed-scroll').css('top', -scrollTop);
}

/* re-enable scrolling */
function unsetScrollFix() {
	let html = $('html'),
		scrollTop = parseInt(html.css('top'));

	html.removeClass('fixed-scroll');
	$(window).scrollTop(-scrollTop);
}

/* Collapse Container */
/* each container can have one or more toggles to open/close it */
function collapse() {
	let container = $('.collapse-container');

	container.each(function() {
		let element = $(this),
			toggle = $('.' + element.data('toggle'));

		toggle.each(function() {
			let $thisToggle = $(this);

			if (element.hasClass('collapsed')) {
				$thisToggle.addClass('collapsed');
			}

			$thisToggle.off('click').on('click', function() {
				handleContainer($thisToggle);
			});
		});

		function handleContainer(t) {
			let action = t.data('collapse-action');

			if (action && action == 'open') {
				element.removeClass('collapsed');
				toggle.removeClass('collapsed');
			} else if (action && action == 'close') {
				element.addClass('collapsed');
				toggle.addClass('collapsed');
			} else {
				element.toggleClass('collapsed');
				toggle.toggleClass('collapsed');
			}
		}
	});
}

/* Top navigation */
function handleDesktopNavigation() {
	let navigationContainer = $('.userbar__navigation');
	let naviLinks = $(navigationContainer).find('a');

	setActiveLink(window.location.hash);

	naviLinks.on('click', function(event) {
		let clickedLinkElement = event.target;
		setActiveLink(clickedLinkElement.href);
	});

	function setActiveLink(url) {
		[].slice.call(naviLinks).forEach(function(linkElement) {
			if (url && linkElement.href.search(new RegExp(url + '$', 'i')) !== -1) {
				$(linkElement).addClass('active');
			} else {
				$(linkElement).removeClass('active');
			}
		});
	}
}

function eventBeacon() {
	if (typeof evtBeacon === 'undefined'
		|| typeof evtBeacon.event === 'undefined'
	    || typeof evtBeacon.url === 'undefined') {
		return;
	}

	$.ajax({
		type: 'POST',
		url: evtBeacon.url,
		data: {
			event: "landingpages_" + evtBeacon.event
		},
		xhrFields: {
			withCredentials: true
		},
		dataType: 'json',
		complete: function () {
			funnelTracking();
		}
	});
}

function funnelTracking() {
	if (typeof hawkeyeDomain === 'undefined') {
		return;
	}

	// use c_id set by event beacon to identify tracking event
	let c_id = getCookie('c_id');
	if(c_id === null) {
		return;
	}

	$.ajax({
		type: 'POST',
		url: hawkeyeDomain + '/api/v1/entrance/',
		headers: {
			'X-Visitor-Id': c_id
		},
		data: {
			site: window.location.href,
			referrer: document.referrer,
			utag_data: utag_data
		},
		xhrFields: {
			withCredentials: true
		},
		dataType: 'json'
	});
}

function getCookie(name) {
	let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	return v ? v[2] : null;
}
